import React, { useState, useEffect } from 'react';
import axios from 'axios';

// =============================================
// LANDING PAGE
// =============================================
export function LandingPage() {
  const [plans, setPlans] = useState([]);
  const [settings, setSettings] = useState({});
  useEffect(() => {
    axios.get('/api/public/plans').then(r => setPlans(r.data)).catch(() => {});
    axios.get('/api/public/settings').then(r => setSettings(r.data)).catch(() => {});
  }, []);
  const host = typeof window !== 'undefined' ? window.location.hostname : '';
  const brand = host.startsWith('parlour') ? 'parlour' : host.startsWith('dentist') ? 'dentist' : 'barber';
  const isParlour = brand === 'parlour';
  const brandName = brand === 'parlour' ? 'ParlourHub' : brand === 'dentist' ? 'DentistHub19' : 'BarberHub';
  const brandIcon = brand === 'parlour' ? '💄' : brand === 'dentist' ? '🦷' : '✂️';
  const heroTitle = brand === 'parlour' ? 'Beauty Parlour Booking' : brand === 'dentist' ? 'Dentist Appointment Booking' : 'Barber Booking';
  const heroDesc = brand === 'parlour' ? 'Apne qareeb beauty parlour dhundein, services dekhein, aur WhatsApp se asaan booking karein' : brand === 'dentist' ? 'Apne qareeb dentist dhundein, services dekhein, aur WhatsApp se asaan appointment booking karein' : 'Apne qareeb barber shop dhundein, services dekhein, aur WhatsApp se asaan booking karein';
  const ownerType = brand === 'parlour' ? 'beauty parlour' : brand === 'dentist' ? 'dental clinic' : 'barber shop';
  const ownerBrand = brandName;
  const heroBg = brand === 'parlour' ? 'https://images.unsplash.com/photo-1560066984-138dadb4c035?w=1600&q=80' : brand === 'dentist' ? 'https://images.unsplash.com/photo-1629909613654-28e377c37b09?w=1600&q=80' : 'https://images.unsplash.com/photo-1503951914875-452162b0f3f1?w=1600&q=80';

  return (
    <div style={{ background: 'var(--bg)' }}>
      {/* Nav */}
      <nav style={{ background: 'var(--primary)', padding: '14px clamp(12px, 4vw, 32px)', display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: '8px', flexWrap: 'wrap', position: 'sticky', top: 0, zIndex: 50 }}>
        <h2 style={{ fontFamily: 'Syne', color: 'var(--accent)', fontSize: 'clamp(18px, 5vw, 24px)', whiteSpace: 'nowrap' }}>{brandIcon} {brandName}</h2>
        <div style={{ display: 'flex', gap: '8px' }}>
          <a href="/my-bookings" className="btn btn-outline" style={{ borderColor: 'rgba(255,255,255,0.3)', color: 'white', padding: '8px 16px' }}>📋 Meri Bookings</a>
          <a href="/login" className="btn btn-primary" style={{ padding: '8px 16px' }}>Login</a>
        </div>
      </nav>

      {/* Hero */}
      <div style={{
        background: `linear-gradient(135deg, rgba(26,26,46,0.92) 0%, rgba(233,69,96,0.85) 100%), url('${heroBg}') center/cover no-repeat`,
        color: 'white', padding: '100px 32px', textAlign: 'center', position: 'relative', overflow: 'hidden'
      }}>
        <div style={{
          position: 'absolute', inset: 0,
          background: 'repeating-linear-gradient(45deg, rgba(255,255,255,0.02) 0px, rgba(255,255,255,0.02) 2px, transparent 2px, transparent 10px)',
          pointerEvents: 'none'
        }} />
        <div style={{ position: 'relative', zIndex: 2 }}>
          <div style={{ fontSize: '72px', marginBottom: '20px', filter: 'drop-shadow(0 4px 20px rgba(0,0,0,0.5))' }}>{brandIcon}</div>
          <h1 style={{ fontFamily: 'Syne', fontSize: 'clamp(32px, 8vw, 56px)', lineHeight: 1.15, marginBottom: '20px', textShadow: '0 4px 20px rgba(0,0,0,0.6)', wordBreak: 'break-word' }}>
            Pakistan ka #1<br/><span style={{ color: 'var(--gold)' }}>{heroTitle}</span> Platform
          </h1>
          <p style={{ color: 'rgba(255,255,255,0.95)', fontSize: '19px', maxWidth: '600px', margin: '0 auto 40px', textShadow: '0 2px 10px rgba(0,0,0,0.4)' }}>
            {heroDesc}
          </p>
          <div style={{ display: 'flex', gap: '16px', justifyContent: 'center', flexWrap: 'wrap' }}>
            <a href="/shops" className="btn btn-gold btn-lg" style={{ fontSize: '16px', padding: '16px 36px', boxShadow: '0 10px 30px rgba(245,166,35,0.4)' }}>🔍 Shops Dhundein</a>
            <a href="/login" className="btn btn-outline btn-lg" style={{ borderColor: 'white', color: 'white', fontSize: '16px', padding: '16px 36px', backdropFilter: 'blur(10px)', background: 'rgba(255,255,255,0.1)' }}>{brandIcon} Shop Owner Login</a>
          </div>
        </div>
      </div>

      {/* How it works */}
      <div style={{ padding: '80px 32px', background: 'white' }}>
        <div style={{ maxWidth: '900px', margin: '0 auto', textAlign: 'center' }}>
          <h2 style={{ fontFamily: 'Syne', fontSize: '36px', marginBottom: '48px', color: 'var(--primary)' }}>Kaise Kaam Karta Hai?</h2>
          <div className="grid-3">
            {[
              { icon: '🔍', title: 'Shop Dhundein', desc: `Apne shehar mein ${ownerType} browse karein` },
              { icon: '📅', title: 'Time Select Karein', desc: 'Services dekhein aur apni pasand ki date/time chunein' },
              { icon: '📲', title: 'WhatsApp Booking', desc: 'Ek click mein WhatsApp pe message jayega — confirm ho jaega' },
            ].map((s, i) => (
              <div key={i} style={{ textAlign: 'center', padding: '20px' }}>
                <div style={{ fontSize: '48px', marginBottom: '16px' }}>{s.icon}</div>
                <h3 style={{ fontFamily: 'Syne', marginBottom: '8px', color: 'var(--primary)' }}>{s.title}</h3>
                <p style={{ color: 'var(--text-light)', fontSize: '15px' }}>{s.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Pricing */}
      {plans.length > 0 && (
        <div style={{ padding: '80px 32px', background: 'var(--bg)' }}>
          <div style={{ maxWidth: '900px', margin: '0 auto', textAlign: 'center' }}>
            <h2 style={{ fontFamily: 'Syne', fontSize: '36px', marginBottom: '12px', color: 'var(--primary)' }}>{brand === 'parlour' ? 'Beauty Parlour Owners ke liye Plans' : brand === 'dentist' ? 'Dental Clinic Owners ke liye Plans' : 'Barber Shop Owners ke liye Plans'}</h2>
            <p style={{ color: 'var(--text-light)', marginBottom: '48px' }}>{`Apna ${ownerType} ${ownerBrand} pe register karein`}</p>
            <div className="grid-3">
              {plans.map((plan, i) => (
                <div key={plan.id} className="card" style={{ borderTop: `4px solid ${i === 0 ? '#74b9ff' : i === 1 ? 'var(--accent)' : 'var(--gold)'}`, position: 'relative' }}>
                  {i === 1 && <div style={{ position: 'absolute', top: '-12px', left: '50%', transform: 'translateX(-50%)', background: 'var(--accent)', color: 'white', padding: '4px 16px', borderRadius: '20px', fontSize: '11px', fontWeight: 700 }}>POPULAR</div>}
                  <h3 style={{ fontFamily: 'Syne', marginBottom: '8px' }}>{plan.display_name}</h3>
                  <div style={{ fontSize: '32px', fontFamily: 'Syne', fontWeight: 800, color: 'var(--primary)', margin: '12px 0' }}>
                    PKR {Number(plan.monthly_price).toLocaleString()}
                    <span style={{ fontSize: '14px', fontWeight: 400, color: 'var(--text-light)' }}>/month</span>
                  </div>
                  <p style={{ color: 'var(--text-light)', fontSize: '13px', marginBottom: '16px' }}>{plan.description}</p>
                  <div style={{ fontSize: '13px', textAlign: 'left' }}>
                    {[`👤 Staff: ${plan.max_staff === -1 ? 'Unlimited' : plan.max_staff}`, `📅 Bookings: ${plan.max_bookings_per_month === -1 ? 'Unlimited' : plan.max_bookings_per_month + '/month'}`, `✂️ Services: ${plan.max_services === -1 ? 'Unlimited' : plan.max_services}`, plan.has_gallery ? '📷 Gallery' : null, plan.has_reviews ? '⭐ Reviews' : null].filter(Boolean).map((f, j) => (
                      <div key={j} style={{ padding: '4px 0', color: 'var(--text)' }}>✅ {f}</div>
                    ))}
                  </div>
                  {settings.whatsapp_number && (
                    <a href={`https://wa.me/${settings.whatsapp_number}?text=${encodeURIComponent(`Assalam o Alaikum, main apni ${ownerType} ke liye ${plan.display_name} plan lena chahta hun ${ownerBrand} par.`)}`} target="_blank" rel="noopener noreferrer" style={{ display: 'block', textAlign: 'center', marginTop: '16px', background: '#25D366', color: 'white', padding: '10px', borderRadius: '10px', fontWeight: 700, textDecoration: 'none' }}>
                      📱 WhatsApp pe Order Karein
                    </a>
                  )}
                </div>
              ))}
            </div>
            <p style={{ marginTop: '24px', color: 'var(--text-light)', fontSize: '14px' }}>
              Register karne ke liye upar kisi plan ka WhatsApp button dabayein{settings.contact_email ? <> ya email karein: <a href={`mailto:${settings.contact_email}`} style={{ color: 'var(--accent)' }}>{settings.contact_email}</a></> : null}
            </p>
          </div>
        </div>
      )}

      {/* Footer */}
      <div style={{ background: 'var(--primary)', color: 'rgba(255,255,255,0.5)', padding: '32px', textAlign: 'center', fontSize: '14px' }}>
        <p>{brandIcon} {brandName} Pakistan — Sab se asaan {ownerType} booking platform</p>
        {settings.contact_email && <p style={{ marginTop: '8px', fontSize: '13px', opacity: 0.8 }}>📧 {settings.contact_email}</p>}
      </div>
    </div>
  );
}

// =============================================
// SHOPS LIST
// =============================================
export function ShopsListPage() {
  const host = typeof window !== 'undefined' ? window.location.hostname : '';
  const brand = host.startsWith('parlour') ? 'parlour' : host.startsWith('dentist') ? 'dentist' : 'barber';
  const [shops, setShops] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState('');
  const [city, setCity] = useState('');

  const load = () => {
    setLoading(true);
    const shop_type = brand;
    axios.get('/api/public/shops', { params: { search, city, shop_type } }).then(r => { setShops(r.data); setLoading(false); });
  };

  useEffect(() => { load(); }, []);

  return (
    <div style={{ minHeight: '100vh', background: 'var(--bg)' }}>
      <div style={{ background: 'var(--primary)', padding: '32px 20px', color: 'white' }}>
        <div style={{ maxWidth: '1000px', margin: '0 auto' }}>
          <a href="/" style={{ color: 'rgba(255,255,255,0.6)', textDecoration: 'none', fontSize: '14px' }}>← Home</a>
          <h1 style={{ fontFamily: 'Syne', fontSize: '32px', marginTop: '12px' }}>{brand === 'parlour' ? '💄 Beauty Parlours' : brand === 'dentist' ? '🦷 Dentists' : '✂️ Barber Shops'}</h1>
          <div style={{ display: 'flex', gap: '12px', marginTop: '20px', flexWrap: 'wrap' }}>
            <input className="form-control" placeholder="🔍 Shop naam search karein..." value={search} onChange={e => setSearch(e.target.value)} style={{ flex: 1, minWidth: '200px' }} />
            <input className="form-control" placeholder="📍 City" value={city} onChange={e => setCity(e.target.value)} style={{ width: '150px' }} />
            <button className="btn btn-primary" onClick={load}>Search</button>
          </div>
        </div>
      </div>

      <div style={{ maxWidth: '1000px', margin: '0 auto', padding: '32px 20px' }}>
        {loading ? <div style={{ textAlign: 'center', padding: '60px' }}><div className="spinner" style={{ margin: '0 auto' }} /></div> : (
          <div className="grid-3">
            {shops.map(shop => (
              <a key={shop.id} href={`/shop/${shop.slug}`} style={{ textDecoration: 'none' }}>
                <div className="card card-hover" style={{ cursor: 'pointer', padding: 0, overflow: 'hidden' }}>
                  {shop.cover_image_url ? (
                    <div style={{ height: '140px', backgroundImage: `url(https://barber.brainbox19.com${shop.cover_image_url})`, backgroundSize: 'cover', backgroundPosition: 'center' }} />
                  ) : (
                    <div style={{ height: '140px', background: 'linear-gradient(135deg, var(--primary), var(--accent))', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '48px' }}>{brand === 'parlour' ? '💄' : brand === 'dentist' ? '🦷' : '✂️'}</div>
                  )}
                  <div style={{ padding: '20px' }}>
                  <h3 style={{ fontFamily: 'Syne', fontSize: '16px', marginBottom: '6px', color: 'var(--primary)' }}>{shop.shop_name}</h3>
                  <p style={{ fontSize: '13px', color: 'var(--text-light)', marginBottom: '8px' }}>📍 {shop.city || 'Pakistan'}</p>
                  {shop.avg_rating > 0 && <div style={{ fontSize: '13px', color: 'var(--gold)' }}>{'⭐'.repeat(Math.round(shop.avg_rating))} ({shop.review_count})</div>}
                  {shop.description && <p style={{ fontSize: '12px', color: 'var(--text-light)', marginTop: '8px', lineHeight: 1.5 }}>{shop.description.slice(0, 80)}...</p>}
                  <div className="btn btn-primary btn-sm btn-full mt-4">Book Now →</div>
                  </div>
                </div>
              </a>
            ))}
            {shops.length === 0 && <p style={{ gridColumn: '1/-1', textAlign: 'center', padding: '60px', color: '#999' }}>Koi shop nahi mili</p>}
          </div>
        )}
      </div>
    </div>
  );
}

export default LandingPage;
